var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4Walkthrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 200,
    viewBox: "0 0 143 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_8384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4772 115.357C116.332 115.357 142.156 89.5332 142.156 57.6784C142.156 25.8235 116.332 0 84.4772 0C52.6223 0 26.7988 25.8235 26.7988 57.6784C26.7988 89.5332 52.6223 115.357 84.4772 115.357Z",
    fill: "#2A618D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4773 100.022C107.863 100.022 126.821 81.0641 126.821 57.6784C126.821 34.2928 107.863 15.335 84.4773 15.335C61.0916 15.335 42.1338 34.2928 42.1338 57.6784C42.1338 81.0641 61.0916 100.022 84.4773 100.022Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8617 200C116.717 200 142.54 174.177 142.54 142.322C142.54 110.467 116.717 84.6433 84.8617 84.6433C53.0068 84.6433 27.1833 110.467 27.1833 142.322C27.1833 174.177 53.0068 200 84.8617 200Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3074 184.15C108.693 184.15 127.651 165.192 127.651 141.806C127.651 118.42 108.693 99.4626 85.3074 99.4626C61.9217 99.4626 42.9639 118.42 42.9639 141.806C42.9639 165.192 61.9217 184.15 85.3074 184.15Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1191 143.169C66.1191 132.937 74.4113 124.645 84.6433 124.645C87.754 124.645 90.6812 125.414 93.2501 126.76",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1618 122.146L94.0715 126.847L89.1958 129.46",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.159 143.169C103.159 153.401 94.8665 161.693 84.6345 161.693C80.886 161.693 77.3908 160.575 74.4724 158.661",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2239 163.415L73.7734 158.085L79.1909 156.975",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2896 131.706L73.1258 141.87C72.3785 142.617 72.3785 143.829 73.1258 144.576L83.2896 154.74C84.0369 155.487 85.2485 155.487 85.9958 154.74L96.1595 144.576C96.9068 143.829 96.9068 142.617 96.1595 141.87L85.9958 131.706C85.2485 130.959 84.0369 130.959 83.2896 131.706Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8162 140.216V146.227C80.8162 146.676 81.18 147.04 81.6288 147.04H87.6404C88.0892 147.04 88.453 146.676 88.453 146.227V140.216C88.453 139.767 88.0892 139.403 87.6404 139.403H81.6288C81.18 139.403 80.8162 139.767 80.8162 140.216Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5659 137.839C14.3475 137.673 14.1291 137.507 13.9106 137.332L14.4524 136.642C14.6621 136.808 14.8805 136.974 15.0902 137.14L14.5659 137.839ZM10.6165 134.388C9.57665 133.348 8.59802 132.229 7.69802 131.067L8.38831 130.534C9.27083 131.662 10.2233 132.754 11.2368 133.776L10.6165 134.396V134.388ZM5.199 127.424C4.44755 126.165 3.75726 124.846 3.16309 123.5L3.95823 123.142C4.54367 124.453 5.20774 125.737 5.94172 126.969L5.19027 127.415L5.199 127.424ZM1.6165 119.359C1.27572 118.249 0.987374 117.104 0.751453 115.951C0.690288 115.654 0.637861 115.357 0.585434 115.068L1.44174 114.911C1.49417 115.199 1.54659 115.488 1.60776 115.776C1.83494 116.895 2.12329 118.022 2.45533 119.105L1.6165 119.359ZM0.0611648 110.682C0.0174756 109.992 0 109.275 0 108.567C0 107.799 0.0262135 107.021 0.0699026 106.261L0.943685 106.313C0.899996 107.056 0.873782 107.816 0.873782 108.567C0.873782 109.258 0.891258 109.948 0.934947 110.63L0.0611648 110.682ZM1.47669 102.04L0.620385 101.883C0.891258 100.433 1.25825 98.9908 1.69514 97.6015L2.52523 97.8636C2.09708 99.2267 1.73883 100.634 1.47669 102.049V102.04ZM4.07182 93.8268L3.27668 93.4685C3.87959 92.1316 4.57862 90.8209 5.34755 89.5627L6.09026 90.0171C5.34755 91.2404 4.666 92.5248 4.07182 93.8268ZM8.54559 86.4695L7.8553 85.9278C8.76404 84.7744 9.75141 83.6559 10.7912 82.6249L11.4116 83.2453C10.398 84.2501 9.43685 85.3423 8.54559 86.4695ZM14.6446 80.388L14.1028 79.6977C15.265 78.789 16.4883 77.9501 17.7465 77.1899L18.2009 77.9414C16.9776 78.6841 15.7805 79.5055 14.6446 80.388Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89802 139.264L5.78442 137.516L14.3824 136.974L13.2028 128.437L14.9417 128.201L16.3659 138.599L5.89802 139.264Z",
    fill: "#B51C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0236 41.2804L68.0786 55.2254C66.7273 56.5767 66.7273 58.7676 68.0786 60.1188L82.0236 74.0639C83.3749 75.4152 85.5657 75.4152 86.917 74.0639L100.862 60.1188C102.213 58.7676 102.213 56.5767 100.862 55.2254L86.917 41.2804C85.5657 39.9291 83.3749 39.9291 82.0236 41.2804Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1247 54.1569L84.4684 48.7744L81.8121 54.1569L75.8792 55.022L80.1782 59.2074L79.1646 65.1229L84.4772 62.3355L89.7898 65.1229L88.7762 59.2074L93.0752 55.022L87.1422 54.1569H87.1247Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_8384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142.531,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Walkthrough);
export default __webpack_public_path__ + "static/media/step_4_walkthrough.90ec0a86442c25a6e6f5890cbac5801d.svg";
export { ForwardRef as ReactComponent };